import { useSelector } from 'react-redux';
import { createAction, createReducer } from 'redux-act';

import type { IAbTestingInfo } from '@sravni/ab-testing-sdk/lib/node';

import type { IPageMeta } from '@src/@types/pageMeta';
import type { IGlobalState } from '@src/reducers/index';

type MetadataState = {
  isReviewer: boolean;
  abTestingInfo: IAbTestingInfo | null;
  pageMeta: IPageMeta;
};

const initialState: MetadataState = {
  isReviewer: false,
  abTestingInfo: null,
  pageMeta: {
    isHiddenPskOnCard: false,
    isDisabledCalculator: false,
  },
};

export const setPageMetaData = createAction<IPageMeta>('metadata/setPageMetaData');

export const setReviewer = createAction<boolean>('metadata/setReviewer');
export const setAbTestingInfo = createAction<IAbTestingInfo>('metadata/setAbTestinfInfo');

export const metadataReducer = createReducer<MetadataState>({}, initialState)
  .on(setReviewer, (state, payload) => ({
    ...state,
    isReviewer: payload,
  }))
  .on(setAbTestingInfo, (state, payload) => ({
    ...state,
    abTestingInfo: payload,
  }))
  .on(setPageMetaData, (state, payload) => ({
    ...state,
    pageMeta: payload,
  }));

export function useIsReviewer() {
  return useSelector((state: IGlobalState) => state.metadata.isReviewer);
}

export function useIsDisabledCalculator() {
  return useSelector((state: IGlobalState) => state.metadata?.pageMeta?.isDisabledCalculator);
}
export function useIsHiddenPskCard() {
  return useSelector((state: IGlobalState) => state.metadata?.pageMeta?.isHiddenPskOnCard);
}
